import { Capacitor } from "@capacitor/core";

type CapacitorWindow = Window & {
  Capacitor?: {
    isNativePlatform?: () => boolean;
    getPlatform?: () => string;
  };
};

export const isNativeCapacitorApp = (): boolean => {
  if (typeof window === "undefined") return false;

  if (Capacitor.isNativePlatform()) return true;

  const capacitor = (window as CapacitorWindow).Capacitor;
  return capacitor?.isNativePlatform?.() === true || capacitor?.getPlatform?.() === "ios" || capacitor?.getPlatform?.() === "android" || window.location.protocol === "capacitor:";
};

export const isEmbeddedFrame = (): boolean => {
  if (typeof window === "undefined") return false;

  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export const isLovablePreviewHost = (): boolean => {
  if (typeof window === "undefined") return false;

  const { hostname } = window.location;
  return hostname.includes("id-preview--") || hostname.includes("lovableproject.com");
};

export const isServiceWorkerDisabledByQuery = (): boolean => {
  if (typeof window === "undefined") return false;

  const params = new URLSearchParams(window.location.search);
  return params.get("sw") === "off" || params.has("reset-cache");
};

export const shouldUseServiceWorker = (): boolean => {
  if (typeof navigator === "undefined") return false;

  return (
    "serviceWorker" in navigator &&
    import.meta.env.PROD &&
    !isNativeCapacitorApp() &&
    !isEmbeddedFrame() &&
    !isLovablePreviewHost() &&
    !isServiceWorkerDisabledByQuery()
  );
};
